module.exports = __webpack_public_path__ + "arrow.png?763c26c28640cdd0fe5213cb2aa4e5ca";


//////////////////
// WEBPACK FOOTER
// ./assets/img/arrow.png
// module id = 53
// module chunks = 0